<template>
    <li
    v-if="rating.length != 0"
    class="rating-box">
        <div class="title">
            <h1>评级</h1>
            <el-link
            type="primary"
            :underline="false"
            :href="'/Index/complaintDataDetail.html?website=' + $route.query.name"
            target="_blank">
            更多></el-link>
        </div>

        <div class="con rating">
            <el-table
            :data="rating"
            stripe
            border
            style="width: 100%">
                <el-table-column
                prop="time"
                label="日期">
                </el-table-column>
                <el-table-column
                prop="pre"
                label="平台反馈率">
                </el-table-column>
                <el-table-column
                prop="feedback"
                label="回复时效性">
                </el-table-column>
                <el-table-column
                prop="score_ave"
                label="用户满意度">
                </el-table-column>
                <el-table-column
                prop="buy"
                label="综合指数">
                </el-table-column>
                <el-table-column
                prop="grade"
                label="评级">
                </el-table-column>
            </el-table>
        </div>
    </li>
</template>

<script>
export default {
    name: 'rating',
    data() {
        return {
            filter: [
                // '快手'
            ],
            rating: []
        }
    },
    created() {
        if(this.filter.includes(this.$route.query.name)) {
            return
        }

        axios.get('http://www.315.100ec.cn/api/index.php?_a=data&f=website&website=' + this.$route.query.name)
        .then(res => {
            let green = res.data.if_green
            let arr = []
            delete res.data.if_green
            for(let i in res.data) {
                if(res.data[i].length != 0) {
                    if(green == 0 && res.data[i][0].buy == 0) {
                        res.data[i][0].grade = '不予评级'
                    }

                    arr.push(
                        {
                            time: res.data[i][0].ctime.slice(0, 10),
                            pre: res.data[i][0].pre + '%',
                            feedback: res.data[i][0].feedback,
                            score_ave: res.data[i][0].score_ave,
                            buy: res.data[i][0].buy,
                            grade: res.data[i][0].grade
                        }
                    )
                }
            }
            this.rating = arr.slice(0, 5)
        })
    }
}
</script>